import React from 'react';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';
import { IMPERSONATION_STATUS_OPTIONS } from '../../constants';

const ImpersonationStatusFilter = () => (
  <IconFilter
    multiple
    hasApplyButton
    clearable
    name="status"
    position="bottom right"
    placement="bottom-end"
    as={FilterSelectComponent}
    options={IMPERSONATION_STATUS_OPTIONS}
  />
);

export default ImpersonationStatusFilter;
